import React from "react";
import {Drawable} from "../../../res/images/Drawable";
import Spotlight from "../../../utils/Spotlight";
import {QuickGuideStep} from "../../../model/QuickGuideStep";
import {delay} from "../../../utils/Delay";

export const STEP_DELAY = 4000;

export interface QuickGuideStates {
    x: number;
    y: number;
    radius: number;
    screen: string;
    height?: number;
    width?: number;
    top?: number;
    left?: number;
    tooltip?: string;
}

export interface QuickGuideProps {
    steps?: [QuickGuideStep]
}

export class QuickGuide extends React.Component<QuickGuideProps, QuickGuideStates> {

    state: QuickGuideStates

    constructor(props: QuickGuideProps) {
        super(props)
        this.handleLoad = this.handleLoad.bind(this);
        let firstStep = this.props.steps?.[0];
        this.state = {
            x: firstStep?.x || 0,
            y: firstStep?.y || 0,
            radius: firstStep?.radius || 0,
            screen: Drawable.quickGuide.default,
            width: 0,
            height: 0,
            top: 0,
            left: 0
        };
    }

    componentDidMount() {
        window.addEventListener('load', this.handleLoad);
    }

    startFlow = (step: number = 0) => {
        if (typeof this.props.steps !== "undefined") {
            let steps = this.props.steps
            delay(step === 0 ? 0 : STEP_DELAY, () => {
                this.runStep(steps[step])
            }).then(() => {
                step += 1;
                if (typeof steps[step] === "undefined") {
                    step = 0;
                }
                this.startFlow(step)
            })
        }
    }

    runStep = (step: QuickGuideStep) => {
        this.setState(
            {
                x: step.x,
                y: step.y,
                radius: step.radius,
                screen: Drawable.get(step.screen),
                tooltip: step.tooltip
            }
        );
    }

    handleLoad() {
        const screen = document.getElementById("screen")
        const height = screen?.clientHeight;
        const width = screen?.clientWidth;
        const top = screen?.offsetTop;
        const left = screen?.offsetLeft;
        this.setState({
            height: height,
            width: width,
            top: top,
            left: left
        });

        this.startFlow()

    }

    goBack = () => {
        if (window.history.length === 1) {
            window.location.replace("/")
        } else {
            window.history.back()
        }
    }

    render() {
        return <div
            style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
            }}>

            <div style={{
                position: 'absolute',
                zIndex: 999999
            }}>
                <p
                    className="spotlightTip"
                    dangerouslySetInnerHTML={{__html: this.state.tooltip!}}/>
            </div>
            <img
                id="screen"
                style={{
                    position: "absolute",
                    height: "100%",
                    width: "auto",
                    margin: "auto"
                }}
                src={this.state.screen}/>
            <Spotlight
                width={this.state.width}
                height={this.state.height}
                x={this.state.x}
                y={this.state.y}
                top={this.state.top}
                left={this.state.left}
                color="#A42136"
                radius={this.state.radius}
                responsive
                usePercentage
                animSpeed={1000}
                borderColor="#ddd"
                borderWidth={5}/>
            <a>
                as
                <img
                    style={{
                        top: '16pt',
                        right: '16pt',
                        zIndex: 999999
                    }}
                    onClick={this.goBack}
                    className="closeButton"
                    src={Drawable.close}/>
            </a>
        </div>
    }

}
